import { render, staticRenderFns } from "./LicenseSelector.vue?vue&type=template&id=557e32f9"
import script from "./LicenseSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./LicenseSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports